import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function PrivacyPolicyPage() {
  return (
    <div className="bg-white min-h-screen">
      <Navbar />
      <main className="max-w-3xl mx-auto px-6 md:px-10 pt-32 pb-24">
        <h1 className="text-3xl font-bold text-gray-900 mb-2" style={{ fontFamily: 'Inter, sans-serif' }}>
          プライバシーポリシー
        </h1>

        {[
          {
            title: '1. 個人情報の収集について',
            content:
              'K・Sキャピタル合同会社（以下「当社」）は、お問い合わせフォームやサービス利用を通じて、氏名・会社名・メールアドレス・電話番号等の個人情報を収集することがあります。',
          },
          {
            title: '2. 個人情報の利用目的',
            content:
              '収集した個人情報は、以下の目的で利用します。\n・お問い合わせへの回答および対応\n・サービスの提供・改善\n・重要なお知らせの送付\n・法令に基づく対応',
          },
          {
            title: '3. 個人情報の第三者提供',
            content:
              '当社は、法令に基づく場合を除き、ご本人の同意なく個人情報を第三者に提供することはありません。',
          },
          {
            title: '4. 個人情報の管理',
            content:
              '当社は、個人情報の漏洩・滅失・毀損を防止するため、適切なセキュリティ対策を実施します。個人情報へのアクセスは必要最小限の担当者に限定します。',
          },
          {
            title: '5. Cookieの使用',
            content:
              '当社のウェブサイトでは、サービス向上のためCookieを使用することがあります。ブラウザの設定によりCookieを無効にすることができますが、一部機能が制限される場合があります。',
          },
          {
            title: '6. 個人情報の開示・訂正・削除',
            content:
              'ご本人から個人情報の開示・訂正・削除のご要望があった場合、合理的な期間内に対応いたします。お問い合わせフォームよりご連絡ください。',
          },
          {
            title: '7. プライバシーポリシーの変更',
            content:
              '当社は、必要に応じて本ポリシーを変更することがあります。変更後のポリシーは本ページに掲載した時点で効力を生じます。',
          },
          {
            title: '8. お問い合わせ',
            content:
              '個人情報の取り扱いに関するお問い合わせは、下記までご連絡ください。\n\nK・Sキャピタル合同会社\n〒174-0065 東京都板橋区小豆沢3-3-4-305',
          },
        ].map((section) => (
          <section key={section.title} className="mb-8">
            <h4 className="text-gray-900 font-semibold text-base mb-3">
              <a id={section.title} className="scroll-mt-24">{section.title}</a>
            </h4>
            <p className="text-gray-600 text-sm leading-relaxed whitespace-pre-line">{section.content}</p>
          </section>
        ))}
      </main>
      <Footer />
    </div>
  );
}
